import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../../../components/AppIcon';

const RequestFilters = ({ filters, onFiltersChange, totalCount }) => {
  const { t } = useTranslation();

  const statusOptions = [
    { value: 'all', label: t('All Status'), count: null },
    { value: 'pending', label: t('Pending'), count: null },
    { value: 'approved', label: t('Approved'), count: null },
    { value: 'rejected', label: t('Rejected'), count: null }
  ];

  const typeOptions = [
    { value: 'all', label: t('All Types') },
    { value: 'missing-clockout', label: t('Missing Clock Out') },
    { value: 'incorrect-time', label: t('Incorrect Time') },
    { value: 'missing-entry', label: t('Missing Entry') },
    { value: 'break-time', label: t('Break Time Correction') }
  ];

  const dateRangeOptions = [
    { value: 'all', label: t('All Time') },
    { value: 'week', label: t('Last 7 Days') },
    { value: 'month', label: t('Last 30 Days') },
    { value: 'quarter', label: t('Last 90 Days') }
  ];

  const handleFilterChange = (filterType, value) => {
    onFiltersChange?.({
      ...filters,
      [filterType]: value
    });
  };

  const clearAllFilters = () => {
    onFiltersChange?.({
      status: 'all',
      dateRange: 'all',
      type: 'all'
    });
  };

  const hasActiveFilters = () => {
    return filters?.status !== 'all' || filters?.dateRange !== 'all' || filters?.type !== 'all';
  };

  return (
    <div className="flex flex-1 flex-col bg-card border border-border rounded-xl p-4 justify-between">
      <div className="flex flex-1 flex-row ">
        {/* Filters */}
        <div className="flex flex-1 flex-row items-center gap-4">
          {/* Status Filter */}
          <div className="flex items-center space-x-2">
            <Icon name="Filter" size={16} className="text-muted-foreground" />
            <select
              value={filters?.status}
              onChange={(e) => handleFilterChange('status', e?.target?.value)}
              className="px-3 py-2 text-sm border border-border rounded-lg bg-background focus-visible:ring-2 focus-visible:ring-primary/20 focus-visible:border-primary transition-colors"
            >
              {statusOptions?.map(option => (
                <option key={option?.value} value={option?.value}>
                  {option?.label}
                </option>
              ))}
            </select>
          </div>

          {/* Type Filter */}
          <div className="flex items-center space-x-2">
            <Icon name="Tag" size={16} className="text-muted-foreground" />
            <select
              value={filters?.type}
              onChange={(e) => handleFilterChange('type', e?.target?.value)}
              className="px-3 py-2 text-sm border border-border rounded-lg bg-background focus-visible:ring-2 focus-visible:ring-primary/20 focus-visible:border-primary transition-colors"
            >
              {typeOptions?.map(option => (
                <option key={option?.value} value={option?.value}>
                  {option?.label}
                </option>
              ))}
            </select>
          </div>

          {/* Date Range Filter */}
          <div className="flex items-center space-x-2">
            <Icon name="Calendar" size={16} className="text-muted-foreground" />
            <select
              value={filters?.dateRange}
              onChange={(e) => handleFilterChange('dateRange', e?.target?.value)}
              className="px-3 py-2 text-sm border border-border rounded-lg bg-background focus-visible:ring-2 focus-visible:ring-primary/20 focus-visible:border-primary transition-colors"
            >
              {dateRangeOptions?.map(option => (
                <option key={option?.value} value={option?.value}>
                  {option?.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Results and Clear Filters */}
        <div className="flex items-center justify-between sm:justify-end space-x-4">
          <div className="flex items-center space-x-3">
            {hasActiveFilters() && (
              <button
                onClick={clearAllFilters}
                className="flex items-center space-x-1 text-sm text-orange-600 hover:text-orange-700 transition-colors"
              >
                <Icon name="X" size={14} />
                <span>{t('Clear filters')}</span>
              </button>
            )}
          </div>

          {/* Export Button */}
          {/* <button className="flex items-center space-x-2 px-3 py-2 text-sm font-medium text-muted-foreground bg-muted/30 rounded-lg hover:bg-muted/50 transition-colors">
            <Icon name="Download" size={14} />
            <span>Export</span>
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default RequestFilters;